export default {
    breakpointLarge: '@media screen and (min-width: 64em)',
    breakpointMedium: '@media screen and (max-width: 63.9999em)',
    breakpointPhone: '@media screen and (max-width : 31em)',
    breakpointLargePixels: 1030,
    breakpointPhonePixels: 496
};